exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* purgecss start ignore */\n.v-main[data-v-4d0786c5] {\n  background-color: #4c8dff !important;\n}\n.login-container[data-v-4d0786c5] {\n  height:550px; display:flex; justify-content: center;\n  align-items: center;\n}\n.login-card[data-v-4d0786c5]{\n  margin: auto;\n  padding: 20px;\n}\n\n/* purgecss end ignore */\n", ""]);

// exports
